import React, { PureComponent } from 'react';
import { Form, Input, message } from 'antd';
import get from 'lodash/get';
import Modal from '../../../../../components/Modal';
import { updateCustomerDetails } from '../api';
import BookingPageContext from '../../../context';

const FormItem = Form.Item;

class CustomerEditModal extends PureComponent {
  static contextType = BookingPageContext;

  state = {
    confirmLoading: false,
  };

  onValidateForm = (segment) => {
    const { closePopup, customer } = this.props;

    this.props.form.validateFields(async (err, values) => {
      if (err) return;

      try {
        this.setState({ confirmLoading: true });
        await updateCustomerDetails(customer.id, { ...values, segment });
        closePopup();
        this.context.reloadBooking();
      } catch (error) {
        message.error(get(error, 'response.data.message', error.message));
        this.setState({ confirmLoading: false });
      }
    });
  };

  render() {
    const { closePopup, getFieldDecorator, openedPopup, segment } = {
      ...this.props,
      getFieldDecorator: this.props.form.getFieldDecorator,
    };

    return (
      <Modal
        title="Edit customer details of"
        visible={openedPopup === 'CustomerEditModal'}
        onOk={() => this.onValidateForm(segment)}
        onCancel={closePopup}
        okText="Save"
        confirmLoading={this.state.confirmLoading}
      >
        <Form>
          <FormItem>
            {getFieldDecorator('firstName', {
              rules: [{ required: true, message: 'Please enter customer first name' }],
            })(<Input placeholder="First Name" />)}
          </FormItem>

          <FormItem>
            {getFieldDecorator('lastName', {
              rules: [{ required: true, message: 'Please enter customer last name' }],
            })(<Input placeholder="Last Name" />)}
          </FormItem>

          <FormItem>
            {getFieldDecorator('email', {
              rules: [
                { required: true, message: 'Please enter customer email' },
                { type: 'email', message: 'Please enter a valid email' },
              ],
            })(<Input placeholder="Email" />)}
          </FormItem>

          <FormItem>
            {getFieldDecorator('mobileNumber', {
              rules: [{ required: true, message: 'Please enter mobile number' }],
            })(<Input placeholder="Mobile Number" />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({
  mapPropsToFields(props) {
    const { customer } = props;

    return Object.keys(customer).reduce((accumulator, currentValue) => {
      accumulator[currentValue] = Form.createFormField({
        value: customer[currentValue],
      });
      return accumulator;
    }, {});
  },
})(CustomerEditModal);
